import Icon from '../components/Icon.vue'

Icon.register({
  'file-code': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M384 121.9V128H256V0H262.1C268.4 0 274.5 2.5 279 7L377 105A24-24 0 0 0 384 121.9zM248 160C234.8 160 224 149.2 224 136V0H24C10.7 0 0 10.7 0 24V488C0 501.3 10.7 512 24 512H360C373.3 512 384 501.3 384 488V160H248zM123.2 400.5A5.4-5.4 0 0 0 115.6 400.8L50.7 339.9A5.4-5.4 0 0 0 50.7 332.1L115.6 271.2A5.4-5.4 0 0 0 123.2 271.5L142.8 292.4A5.4-5.4 0 0 0 142.4 300.1L101.7 336 142.4 371.9A5.4-5.4 0 0 0 142.8 379.6L123.2 400.5zM174.5 451L147 443A5.4-5.4 0 0 0 143.4 436.3L204.8 224.7A5.4-5.4 0 0 0 211.5 221L239 229A5.4-5.4 0 0 0 242.6 235.7L181.2 447.3A5.4-5.4 0 0 0 174.5 451zM335.3 339.9L270.4 400.8A5.4-5.4 0 0 0 262.8 400.5L243.2 379.6A5.4-5.4 0 0 0 243.6 371.9L284.4 336 243.6 300.1A5.4-5.4 0 0 0 243.2 292.4L262.8 271.5A5.4-5.4 0 0 0 270.4 271.2L335.3 332.1A5.4-5.4 0 0 0 335.3 339.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/file-code.js
// module id = zh5D
// module chunks = 144